import { render, staticRenderFns } from "./RmwLogin.vue?vue&type=template&id=45dc6ae8&scoped=true"
import script from "./RmwLogin.vue?vue&type=script&lang=js"
export * from "./RmwLogin.vue?vue&type=script&lang=js"
import style0 from "./RmwLogin.vue?vue&type=style&index=0&id=45dc6ae8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dc6ae8",
  null
  
)

export default component.exports